module.exports = __webpack_public_path__ + "static/media/line-small-dashed-white.f27259d5.svg";